import {
  GET_LIST_MENU,
  PROMISE_PENDING,
  PROMISE_REJECTED,
  PROMISE_FULFILLED,
  FETCH_FAQS,
  GET_TIMER
} from "../constants";
import error from "../utils/error";

const initialState = {
  list: [],
  isFetch: false,
  error: null,
  section_name: "",
  countdown_modal: true,
  faqs: {},
  timer: {
    isFetch: false,
    title: "",
    description: "",
    terms_url: "",
    start: null,
    end: null
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${GET_LIST_MENU}${PROMISE_PENDING}`:
      return { ...state, isFetch: true };
    case `${GET_LIST_MENU}${PROMISE_FULFILLED}`:
      const { data, status_code, message } = action.payload;
      return {
        ...state,
        list: { data, status_code, message },
        error: null,
        isFetch: false,
      };
    case `${GET_LIST_MENU}${PROMISE_REJECTED}`:
      return { ...state, ...error(action.payload), isFetch: false };
    case `${FETCH_FAQS}${PROMISE_PENDING}`:
      return { ...state, isFetch: true };
    case `${FETCH_FAQS}${PROMISE_FULFILLED}`:
      return {
        ...state,
        faqs: { data: action.payload.data, status_code: action.payload.status_code, message: action.payload.message },
        error: null,
        isFetch: false,
      };
    case `${FETCH_FAQS}${PROMISE_REJECTED}`:
      return { ...state, ...error(action.payload), isFetch: false };
    case "SCROLL_SECTION_FAQ":
      return { ...state, section_name: action.payload };
    case `${GET_TIMER}${PROMISE_PENDING}`:
      return {
        ...state,
        timer: {
          ...state.timer,
          isFetch: true
        }
      };
    case `${GET_TIMER}${PROMISE_FULFILLED}`: {
      const { data: { data } } = action.payload;
      const dataTimer = data.find((item) => item.active);

      return {
        ...state,
        timer: {
          ...state.timer,
          isFetch: false,
          title: dataTimer?.name ?? "",
          description: dataTimer?.content ?? "",
          terms_url: dataTimer?.terms_url ?? "",
          start: dataTimer?.started_at ?? null,
          end: dataTimer?.ended_at ?? null
        }
      };
    }
    case `${GET_TIMER}${PROMISE_REJECTED}`:
      return {
        ...state,
        timer: {
          ...state.timer,
          isFetch: false,
          title: "",
          description: "",
          terms_url: "",
          start: null,
          end: null
        }
      }
    case "COUNTDOWN_MODAL":
      return { ...state, countdown_modal: action.payload };
    case `SET_TIMER`: {
      const data = action.payload;
      const dataTimer = data.find((item) => item.active);

      return {
        ...state,
        timer: {
          ...state.timer,
          isFetch: false,
          title: dataTimer?.name ?? "",
          description: dataTimer?.content ?? "",
          terms_url: dataTimer?.terms_url ?? "",
          start: dataTimer?.started_at ?? null,
          end: dataTimer?.ended_at ?? null
        }
      };
    }
    default:
      return state;
  }
};

export default reducer;
